import {Tab, TabbedNavigation} from '../../../../common/components/Tabs';
import Carousel from './Carousel';
import Row from 'react-bootstrap/lib/Row';
import React from 'react';
import PropTypes from 'prop-types';
import {ItemType, CarouselTabs} from '../../../../common/Constants';
import dtmTags from '../../../../common/dtmTags';
import mixpanelConstants from '../../../../common/mixpanelConstants';

const ProductsAndDocumentsWithCarousel = (props) =>{
   const {exhibitorId, products, productsTitle, documentsTitle, translations, getDtmTag, documents} = props;
   const isDocumentTabActive = products.length < 3 && documents.length > 3;
   return <Row>
        { (products.length > 0 || documents.length > 0) &&
        <TabbedNavigation activeTabIndex = {isDocumentTabActive ? CarouselTabs.documentTab : CarouselTabs.productTab}>
            <Tab title={productsTitle} titleSuffix=''
                 tag={props.mixpanelProps?.subComponent === mixpanelConstants?.subComponent.priority ? dtmTags.exhibitorDirectory.productsTab + dtmTags.exhibitorDirectory.prioritySlot : dtmTags.exhibitorDirectory.productsTab}
                 dtmAttribute={JSON.stringify({ exhibitorId: exhibitorId,
                     package: props.mixpanelProps?.packageName })}
                 mixpanelProps={props.mixpanelProps}
            >
                <Carousel
                    items={products}
                    translations = {translations}
                    exhibitorId = {exhibitorId}
                    type={ItemType.Product}
                    onClick = {props.onClick}
                    mixpanelProps={props.mixpanelProps}
                    getDtmTag={getDtmTag}
                />
            </Tab>
            <Tab title={documentsTitle} titleSuffix=''
                 tag={props.mixpanelProps?.subComponent === mixpanelConstants?.subComponent.priority ? dtmTags.exhibitorDirectory.documentsTab + dtmTags.exhibitorDirectory.prioritySlot : dtmTags.exhibitorDirectory.documentsTab}
                 dtmAttribute={JSON.stringify({ exhibitorId: exhibitorId, package: props.mixpanelProps?.packageName })}
                 mixpanelProps={props.mixpanelProps}
            >
                <Carousel
                    items={documents}
                    translations = {translations}
                    exhibitorId = {exhibitorId}
                    type={ItemType.Document}
                    onClick = {props.onClick}
                    mixpanelProps={props.mixpanelProps}
                    getDtmTag={getDtmTag}
                />
            </Tab>
        </TabbedNavigation>}
    </Row>
}

ProductsAndDocumentsWithCarousel.propTypes = {
    exhibitorId:PropTypes.string.isRequired,
    documents: PropTypes.array.isRequired,
    products:PropTypes.array.isRequired,
    productsTitle:PropTypes.string.isRequired,
    documentsTitle:PropTypes.string.isRequired,
    translations:PropTypes.object.isRequired,
    getDtmTag:PropTypes.func.isRequired,
    onClick:PropTypes.func.isRequired,
    mixpanelProps: PropTypes.object,
}

export default ProductsAndDocumentsWithCarousel;
